import React, {createContext, useContext, useEffect, useState} from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({children}) => {
  const [theme, setTheme] = useState(() => {
    // Get the initial theme from localStorage or default to 'dark'
    // return localStorage.getItem('theme') || 'dark';
    return 'dark';
  });

  const toggleTheme = () => {
    // setTheme((prevTheme) => (prevTheme === 'dark' ? 'white' : 'dark'));
  };

  useEffect(() => {
    // Save the theme to localStorage whenever it changes
    localStorage.setItem('theme', theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{theme, toggleTheme}}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);